// extracted by mini-css-extract-plugin
export default {"cmsParagraphReveal":"CmsParagraphReveal_cmsParagraphReveal__-Vjom","word":"CmsParagraphReveal_word__ncs3G"};